import React from "react";
import proj1 from "../assets/project1.jpeg";
import proj2 from "../assets/project2.png";
import proj3 from "../assets/project3.png";
import proj4 from "../assets/project4.png";
import proj5 from "../assets/project5.png";
import proj6 from "../assets/project6.png";
import deliveryYa from "../assets/deliveryYa.jpg";
import countryLens from "../assets/countryLens.png";
import ecoBin from "../assets/ecoBin.png";
import giphy from "../assets/giphy.gif";
import { AiFillGithub, AiFillChrome } from "react-icons/ai";

const Portfolio = () => {
  return (
    <div
      className="px-6 pt-16 pb-10 sm:pb-16 lg:pb-16 max-w-[1400px] mx-auto"
      id="portfolio"
    >
      <div className="grid md:grid-cols-2 mb-16">
        {/* Left Column: Giphy */} 
        <div className="md:order-1 flex items-center justify-center">
          <img
            src={giphy}
            className="w-full md:w-[550px] md:h-[300px] pr-6"
            alt="alt giphy"
          />
        </div>

        {/* Right Column: Text */}
        <div className="text-gray-300 my-auto text-center md:text-left md:order-2">
          <h1 className="text-5xl mb-8 tracking-tight">My Work</h1>
          <p className="text-xl text-justify leading-relaxed max-w-[500px] mx-auto md:mx-0">
            I enjoy building full-stack applications that solve real-world
            problems and improve user experiences. From managing community
            systems to developing event planning platforms, I approach each
            project with a strong emphasis on clean architecture, performance,
            and maintainability.
            <br />
            <br />
            I’m constantly experimenting with new tools and frameworks, and I
            love exploring how different technologies fit into scalable system
            design. Whether it’s creating intuitive UIs with React or building
            RESTful APIs with Spring Boot, I strive to write meaningful,
            production-ready code.
          </p>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {/* Project 1 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/DelieveryYa"
            className="group col-span-3"
          >
            <img
              src={deliveryYa}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #1</h2>
            <p className="text-gray-400">
              <b>DeliveryYa – Food Delivery Platform</b>
              <br /> <br />
              Contributed to a scalable microservices platform using Spring
              Boot, React.js, MySQL, Redis, Kafka, and WebSocket for real-time
              tracking. Implemented secure services with JWT and Spring Cloud
              Gateway, and assisted with Docker and Kubernetes deployment.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/DelieveryYa"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 2 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://country-lens-ochre.vercel.app/"
            className="group col-span-3"
          >
            <img
              src={countryLens}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #2</h2>
            <p className="text-gray-400">
              <b>CountryLens – Country Explorer App</b>
              <br />
              <br />A modern React app powered by REST Countries API and Vite,
              enabling users to explore global data with fast performance and a
              clean UI. Features include searching, filtering by
              region/language, and viewing detailed country info with an
              interactive Leaflet map. Users can log in to save favorites (Pro
              mode).
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://country-lens-ochre.vercel.app/"
            >
              <AiFillChrome className="w-[35px] h-auto" />
            </a>
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/CountryLens"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 3 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/Eco-Bin_App"
            className="group col-span-3"
          >
            <img
              src={ecoBin}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #3</h2>
            <p className="text-gray-400">
              <b>EcoBin – Mobile-Based Smart Garbage Collection System</b>
              <br /> <br />
              Built a mobile app integrating IoT Smart Bins, real-time QR
              scanning, and AI-powered route optimization. Automated garbage
              collection, enhanced operational efficiency, and promoted
              recycling with user incentives.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/Eco-Bin_App"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 4 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/Cleansy-FMS"
            className="group col-span-3"
          >
            <img
              src={proj3}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #4</h2>
            <p className="text-gray-400">
              <b>Cleansy - Sustainable Community management System</b>
              <br /> <br /> This project is a sophisticated web application
              built on the MERN stack (MongoDB, Express.js, React.js, Node.js).
              It includes various features aimed at streamlining community
              interactions and enhancing user experience.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/Cleansy-FMS"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 5 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/WildTrek_Safari_Management_System"
            className="group col-span-3"
          >
            <img
              src={proj2}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #5</h2>
            <p className="text-gray-400">
              <b>WildTrek - Safari Management System </b>
              <br />
              <br />
              Explore WildTrek, a comprehensive solution for efficient safari
              planning and management. This robust and innovative platform
              offers streamlined booking, wildlife tracking, and robust
              administration, ensuring an unforgettable and well-organized
              safari adventure experience.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/WildTrek_Safari_Management_System"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 6 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/ExquisitePlanners-Event-planning-system"
            className="group col-span-3"
          >
            <img
              src={proj1}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #6</h2>
            <p className="text-gray-400">
              <b>ExquisitePlanners - Event planning system </b>
              <br />
              <br />A robust online reservation platform designed to provide
              seamless event booking experiences. Built with Java Servlets and
              adhering to the Model-View-Controller (MVC) architecture, this
              application ensures high performance, scalability, and
              maintainability.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/ExquisitePlanners-Event-planning-system"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 7 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/QuickJot"
            className="group col-span-3"
          >
            <img
              src={proj4}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #7</h2>
            <p className="text-gray-400">
              <b>QuickJot - Task management app</b>
              <br />
              <br />
              QuickJot is a versatile note-taking application designed to
              streamline your daily tasks and enhance productivity. With its
              intuitive interface and robust features, QuickJot allows users to
              capture thoughts, ideas, and to-do lists all in one convenient
              platform.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/QuickJot"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 8 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://github.com/Pradi-Hub/Rock_Paper_Scissor"
            className="group col-span-3"
          >
            <img
              src={proj5}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #8</h2>
            <p className="text-gray-400">
              <b>Rock Paper Scissor - Game app</b>
              <br />
              <br />
              The Rock Paper Scissor game app is a classic and entertaining game
              that brings the age-old hand game to your fingertips. It offers a
              fun and interactive way to challenge your friends or play against
              the computer in a battle of wits and strategy.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/Rock_Paper_Scissor"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
        {/* Project 9 */}
        <div className="rounded-xl bg-black/40 overflow-hidden shadow-xl z-1">
          <a
            href="https://www.figma.com/proto/KhhNrIjoIV9dVzM2NHjgBw/InventoMate?type=design&node-id=100-101&t=KAQt0PefYpbMAdgP-0&scaling=scale-down&page-id=0%3A1"
            className="group col-span-3"
          >
            <img
              src={proj6}
              alt=""
              className="h-[200px] w-full object-cover object-top transition duration-200 group-hover:scale-110 rounded-lg"
            />
          </a>
          <div className="p-4">
            <h2 className="text-gray-200">Project #9</h2>
            <p className="text-gray-400">
              <b>InventoMate - Inventory management app</b>
              <br />
              <br />
              InventoMate is a cutting-edge inventory management application for
              mobile devices, providing seamless stock tracking and optimization
              solutions for businesses across industries. This app addresses the
              challenges of maintaining accurate inventory levels efficiently.
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-end text-white mb-3 mr-3">
            <a
              className="cursor-pointer"
              href="https://www.figma.com/proto/KhhNrIjoIV9dVzM2NHjgBw/InventoMate?type=design&node-id=100-101&t=KAQt0PefYpbMAdgP-0&scaling=scale-down&page-id=0%3A1"
            >
              <AiFillChrome className="w-[35px] h-auto" />
            </a>
            <a
              className="cursor-pointer"
              href="https://github.com/Pradi-Hub/InventoMate"
            >
              <AiFillGithub className="w-[35px] h-auto" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
